//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionBase,
  Illustration,
  IllustrationSource,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

export default {
  components: {
    Illustration,
    IllustrationSource,
  },
  computed: {
    ...mapGetters({
      bannerInfo: 'landing/bannerInfo',
    }),
    isAdvertBlock() {
      return (
        !isEmpty(this.bannerInfo) &&
        ['mobileImg', 'alt', 'img'].every((attr) => attr in this.bannerInfo)
      )
    },
    hasUrl() {
      return !isEmpty(this.bannerInfo.urlTo)
    },
    isExternalLink() {
      return this.hasUrl && /^https?:\/\//.test(this.bannerInfo.urlTo)
    },
    wrapperImageTag() {
      return this.hasUrl ? ActionBase : 'template'
    },
    wrapperImageProps() {
      return this.hasUrl
        ? {
            to: this.bannerInfo.urlTo,
            target: this.isExternalLink ? '_blank' : '_self',
          }
        : {}
    },
  },
}
